// extracted by mini-css-extract-plugin
export var menuItem = "s_s1 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "s_s2 d_Z d_bz d_bP";
export var menuMainLink = "s_s3 d_f0 d_dB";
export var menuLink = "s_s4 d_f0 d_dB";
export var icon = "s_p9 d_bC d_bP";
export var divider = "s_s5 d_bC d_bP";
export var sublinks = "s_s6";
export var link = "s_mC";
export var Link = "s_rg p_rg p_qt p_qP";